import React, { useEffect, ReactNode, useState } from 'react';
import { omitBy, isNil } from 'lodash';

import { IPageFields } from '../../../types/contentful';

import { usePageAnalytics } from '../../hooks/usePageAnalytics';
import { getCookie } from '../../utils/cookies';
import analytics from '../../utils/analytics';

import { Headers } from './Headers';
import { Footers } from './Footers';
import { Callouts } from './Callouts';

import { Metadata } from '../Metadata';
import { LeadCapture } from '../LeadCapture';

import { Wrapper } from './styles';

interface BodyProps extends IPageFields {
  children?: ReactNode | ReactNode[];
  pathPrefix?: string;
  bgColor?: string;
}

export function Body({
  children,
  pathPrefix,
  bgColor,
  analyticsMetadata,
  hideFooterCta,
  ...page
}: BodyProps) {
  const [displayLeadCapture, setDisplayLeadCapture] = useState(false);

  usePageAnalytics(analyticsMetadata?.fields);

  useEffect(() => {
    const extoleSharableCode = getCookie('extole_shareable_code');
    const advocatePartnerShareId = getCookie('advocate_partner_share_id');
    if (extoleSharableCode || advocatePartnerShareId) {
      analytics.track(
        'Referred User App Opened',
        omitBy(
          {
            extole_shareable_code: `${extoleSharableCode}` || null,
            advocate_partner_share_id: `${advocatePartnerShareId}` || null
          },
          isNil
        )
      );
    }

    window.setIncident = setDisplayLeadCapture;
    setDisplayLeadCapture(!!window.incident);
  }, []);

  return (
    <Wrapper bgColor={bgColor ?? '#FFFFFF'}>
      <Metadata {...page} pathPrefix={pathPrefix ?? ''} />

      <Headers {...page} />

      {displayLeadCapture && <LeadCapture />}

      <main>
        {children}

        {!hideFooterCta && <Callouts {...page} />}
      </main>

      <Footers {...page} />
    </Wrapper>
  );
}
